import kidWidgetConfig from '@kds/kid-widget-config/widget/output/index.js';
import { commonBase } from '@ks/kwcolor/color/output/common/index';
import { font } from '@ks/kw-font/font/output/common/index';
import { useTheme } from './useTheme';
import { useRem } from './useRem';
const useStyleByKidToken = () => {
    const { theme } = useTheme();
    return (kidStyle) => {
        if (kidStyle.KIDToken && kidStyle.KIDType === 'color') {
            // 解析color的token
            return commonBase[kidStyle.KIDToken] || theme[kidStyle.KIDToken];
        }
        else if (kidStyle.KIDToken && kidStyle.KIDType === 'font') {
            // 解析font的token
            return font[kidStyle.KIDToken];
        }
        else {
            // 基本类型
            return kidStyle;
        }
    };
};
export function useStyleVars({ defaultVars, customVars, scalable, kidtoken = '', }) {
    const getStyleByKidToken = useStyleByKidToken();
    const getRem = useRem(scalable);
    let result = {};
    Object.keys(defaultVars).forEach((k) => {
        var _a, _b;
        if (customVars[k] !== undefined) {
            result[k] = customVars[k];
        }
        else if (kidtoken) {
            const kidStyle = (_b = (_a = kidWidgetConfig[kidtoken]) === null || _a === void 0 ? void 0 : _a.widgetStyleData) === null || _b === void 0 ? void 0 : _b.styleConfig[k];
            result[k] = kidStyle
                ? getStyleByKidToken(kidStyle)
                : defaultVars[k];
        }
        else {
            result[k] = defaultVars[k];
        }
        if (k.includes('size') && !k.includes('custom')) {
            const isNumber = typeof result[k] === 'number' && result[k] !== 0;
            result[k] = isNumber ? getRem(result[k]) : result[k];
        }
    });
    return result;
}
